module.exports = __webpack_public_path__ + "img/back2.c12700b0.jpg";